import controller from './enter-data-form-input-controller';
import template from './enter-data-form-input.html';

const EnterDataFormInputComponent = {
    bindings: {
        field: '<',
        inputType: '<',
        isEditMode: '<',
        ngModel: '='
    },
    controller,
    template
};

export default EnterDataFormInputComponent;



// WEBPACK FOOTER //
// ./app/components/enter-data/enter-data-form-input/enter-data-form-input-component.js